




import Vue from "vue";
import {Prop} from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class ColoredBooleanField extends Vue{
  @Prop() value!: boolean;
}
